export default __webpack_public_path__ + "static/media/youtube.0177b740.svg";